import '../scss/main.scss';

console.log('JS loaded');

document.addEventListener("DOMContentLoaded", function() {
    const mobileMenuButton = document.getElementById('mobileMenuButton');
    const navbarLinks = document.getElementById('navbarLinksMobile');

    if (mobileMenuButton && navbarLinks) {
        mobileMenuButton.addEventListener('click', function() {
            if (navbarLinks.style.display === "flex") {
                navbarLinks.style.display = "none";
            } else {
                navbarLinks.style.display = "flex";
            }
        });
    }
});